<template>
    <div id="customers_layout">
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>
        <div is="BackToTopButton"></div>
    </div>
</template>

<script>
import BackToTopButton from '@toolbox/back_to_top_button/main.vue'
export default {
    name: "CustomersLayout",
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init');
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    watch: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await this.$store.dispatch('provider/customers_module/fetch_provider_contracts')
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
        BackToTopButton
    }
}
</script>
<style lang="scss">
</style>
